import { get, post } from "../../../services/request";

export const exportToCSV = (exportAPIURL) => {
    return get(exportAPIURL);
};

export const getDashboardDetails = () => {
    return get('Common/GetDashboardDetails');
};

export const getQgendaTasksAndSchedules = (data) => {
    return post('Qgenda/GetQgendaTasksAndSchedules', data);
};

export const getAllowedMenus = () => {
    return get('MainModules/GetAllowedMenus');
};

export const exportToCSVWithPost = (exportAPIURL, payload) => {
    return post(exportAPIURL, payload);
};
export const getAssignedSitesCount = () => {
    return get('SiteManagement/GetAssignedSitesCount');
};

export const getUnassignedSitesCount = () => {
    return get('SiteManagement/GetNoOfUnAssignedSites');
}

export const getAssignedRolesWithPractices = () => {
    return get('AdvancedSchedulingCommon/GetAllAssignedRolesWithPractices');
}